<template>
  <div class="privacy-policy-container">
    <div class="privacy-policy-content">
      <h1>{{ terms.title }}</h1>

      <p class="last-update">
        <strong>{{ terms.lastUpdate }}:</strong> {{ terms.updateDate }}
      </p>

      <div class="section">
        <h2>{{ terms.introduction }}</h2>
        <p v-html="terms.introductionContent"></p>
      </div>

      <div class="section">
        <h2>{{ terms.rewardDescription }}</h2>
        <p v-html="terms.rewardDescriptionContent"></p>
      </div>

      <div class="section">
        <h2>{{ terms.eligibility }}</h2>
        <p v-html="terms.eligibilityContent"></p>
      </div>

      <div class="section">
        <h2>{{ terms.license }}</h2>
        <p v-html="terms.licenseContent"></p>
      </div>

      <div class="section">
        <h2>{{ terms.fraud }}</h2>
        <p v-html="terms.fraudContent"></p>
      </div>

      <div class="section">
        <h2>{{ terms.availability }}</h2>
        <p v-html="terms.availabilityContent"></p>
      </div>

      <div class="section">
        <h2>{{ terms.changes }}</h2>
        <p v-html="terms.changesContent"></p>
      </div>

      <div class="section">
        <h2>{{ terms.contact }}</h2>
        <p v-html="terms.contactContent"></p>
      </div>

      <div class="section consent-section">
        <h2>{{ terms.acceptance }}</h2>
        <p v-html="terms.acceptanceContent"></p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { dioroomTerms } from "@/data/dioroomTerms"

const { locale } = useI18n()

const terms = computed(() => {

  if (locale.value === "pt") {
    return dioroomTerms.pt
  }

  return dioroomTerms.en

})

</script>

<style scoped>
.privacy-policy-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #1e1e2f;
  color: #e0e0e0;
  font-family: Arial, sans-serif;
  padding: 80px;
}

.privacy-policy-content {
  max-width: 800px;
  width: 100%;
  padding: 30px;
  border-radius: 12px;
  background: rgba(34, 34, 51, 0.85);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.5s ease-in-out;
}

.last-update {
  font-size: 1.1em;
  text-align: center;
  color: #cfcfcf;
  margin-bottom: 30px;
}

.section {
  margin-bottom: 25px;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

h2 {
  margin-bottom: 10px;
  color: #ffffff;
}

p {
  font-size: 1.1em;
  line-height: 1.8;
  color: #e0e0e0;
  margin-bottom: 15px;
}

.consent-section p {
  font-style: italic;
  color: #ffd700;
}

strong {
  font-weight: bold;
}

.link {
  color: #ffcc00;
  text-decoration: underline;
}

.link:hover {
  text-decoration: none;
  color: #ffd700;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 768px) {
  .privacy-policy-container {
    padding: 20px;
  }

  .privacy-policy-content {
    padding: 20px;
  }

  p {
    font-size: 1rem;
  }
}
</style>